<div class="d-block">
  <a class="partner-container mb-3 overflow-hidden shadow d-block">
    <div class="partner-item rounded d-flex align-items-center justify-content-center bg-white">
      <div class="partner-image d-flex align-items-center">
        <img class="w-100" src="{{ partner.ImageUrl | contentImage: '7' }}" alt="{{ partner.ImageUrl }}" />
      </div>
    </div>
  </a>
</div>
